import { ChevronRight } from "lucide-react";
import { useNavigate } from "react-router-dom";
import { useStatsOverview } from "@/hooks/useStatsOverview";
import { displayWeight } from "@/lib/utils";
import { useAppStore } from "@/store/app";
import { useEffectiveUser } from "@/hooks/useEffectiveUser";

export function ExerciseBreakdown() {
  const selectedRange = useAppStore((s) => s.selectedDaysRange);
  const { user } = useEffectiveUser();
  const { data } = useStatsOverview(selectedRange ?? 30);

  const navigate = useNavigate();

  return (
    <div>
      <h2 className="text-xl font-bold mb-3 text-tx-dark">
        Exercise Breakdown
      </h2>

      {/* Exercise Items */}
      <div className="space-y-3">
        {data?.exercise_breakdown?.map((exercise) => (
          <div
            key={exercise.nano_id}
            className="flex items-center justify-between space-x-6 p-4 rounded-xl shadow-xs bg-bg-light border border-bd-light cursor-pointer hover:shadow-md transition-shadow duration-200"
            onClick={() =>
              navigate(`/stats/exercise-overview/${exercise.nano_id}`)
            }
          >
            <div className="flex flex-col flex-1">
              {/* 单项训练名称 */}
              <h4 className="font-medium text-base text-primary leading-5 mb-1">
                {exercise.name}
              </h4>

              {/* 单项训练的volume总和 */}
              <h4 className="text-sm rounded-sm text-tx-default">
                <span className="mr-1">Volume:</span>
                {displayWeight(
                  exercise.total_volume_lb,
                  exercise.total_volume_kg,
                  user?.preferred_weight_unit
                )}
              </h4>
            </div>
            <div className="flex items-center justify-between w-20">
              <span aria-hidden="true" className="flex h-9 items-center">
                <span className="relative z-12 flex size-9 items-center justify-center rounded-full border-2 border-primary bg-white">
                  <span className="text-[10px]">
                    {exercise.total_volume_percent}%
                  </span>
                </span>
              </span>

              <ChevronRight className="h-5 w-5" />
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
